'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _drawers = require('./drawers');

var _drawers2 = _interopRequireDefault(_drawers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init() {
  var drawers = (0, _create2.default)(_drawers2.default);
  drawers.init();

  window.drawers = drawers;
}